import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import logincrsimg from "../assets/images/undraw_annotation.png";
import PDFmodal from "../components/PDFmodal";
import smaplepdf from "../assets/PDF/Esign_testDoc(2).pdf";
import ViewDocPopup from "../components/ViewDocPopup";
import { useSelector, useDispatch } from "react-redux";

import {
  checkEsignStatus,
  fetchesignStatus,
  fetchPartyDetailsEsign,
} from "../redux-store/slices/eSignSlice";
import axios from "axios";
import REPORT_BASE_URL from "../utilities/ReportConfig";
import { esignURL } from "../utilities/ApiConfig";

const Esign = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [InputRegno, setInputRegno] = useState("");
  const [open, setOpen] = useState(false);
  const [openFirst, setOpenFirst] = useState(false);
  const [openSecond, setOpenSecond] = useState(false);
  const [pdfBase64, setPdfBase64] = useState("");
  debugger;
  const [emailsent, setEmailSent] = useState(false);
  debugger;
  const pdfUrl = pdfBase64;
  // const [pdfUrl, setPdfUrl] = useState("");

  // const openModal = () => {
  //   const pdfBlob = new Blob([smaplepdf], { type: "application/pdf" });
  //   const blobUrl = URL.createObjectURL(pdfBlob);
  //   setPdfUrl(blobUrl);
  //   setIsModalOpen(true);
  // };

  // Esign start

  const [GeneratePdf, setGeneratePdf] = useState(false);
  const [partyDetailsData, setPartyDetailsData] = useState("");
  const [mudraEsighStatus, setMudraEsighStatus] = useState("");
  const [eregistionEsignDetails, setEregistionEsignDetails] = useState("");
  const dispatch = useDispatch();

  // const { data, statusData, loading, error } = useSelector(
  //   (state) => state.eSign
  // );

  const pde = "UKPDE2024010100230"; //useSelector(selectPdEId);

  const fetchNesseryDetails = async () => {
    const pdd = await fetchPartyDetailsEsign(pde);
    const mes = await checkEsignStatus(pde);
    const eed = await fetchesignStatus(pde);
    setPartyDetailsData(pdd);
    setMudraEsighStatus(mes);
    setEregistionEsignDetails(eed);
  };

  useEffect(() => {
    if (emailsent) {
      console.log("emailsent :", emailsent);
      fetchNesseryDetails();
    }
  }, [emailsent]);

  useEffect(() => {
    if (openSecond === true) {
      generatePdf();
    }
  }, [openSecond]);

  const generatePdf = async () => {
    try {
      setGeneratePdf(true);

      const response = await axios.get(
        `${esignURL}/CrystalPDF/GeneratePdf?pde_id=${pde}`
      );

      if (response.data) {
        setPdfBase64(response.data); // API already returns Base64, so use it directly
      } else {
        console.error("No PDF data received from API.");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setGeneratePdf(false);
    }
  };

  const handleSendClick = async () => {
    const payload = {
      EmpLeaveRec1: {
        API_type: "srotype29aug",
        Client: "sroclient29aug",
        Parameter: `${pde}`,
        DocName: `${pde}.pdf`,
        PDE_ID: pde,
      },
    };

    try {
      //  dispatch(sendEmailLinkToParties(payload));
    } catch (error) {
      console.error("Failed to send email link:", error.message);
    }
  };

  const callapi = async (e) => {
    fetchNesseryDetails();
  };

  const fetchPdf = async () => {
    //debugger;
    try {
      const response = await axios.get(
        `${esignURL}/Home/ViewDownloadSignedDoc?pde_id=UKPDE2024010100230`
      );

      openBase64PdfInNewTab(response.data);
      //debugger;
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const openBase64PdfInNewTab = (base64Pdf) => {
    try {
      // Decode base64 string to binary data
      const binaryString = window.atob(base64Pdf);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create a blob object from the binary data
      const blob = new Blob([bytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      // Open the blob URL in a new tab
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Failed to open PDF:", error);
    }
  };
  // Esign End
  return (
    <div className="flex h-screen">
      <SideMenu />
      <div className="flex-1 flex flex-col">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1">
          {/* Left Side */}
          <div className="flex-1 p-4">
            <div className="p-1 bg-gray-100">
              <div className="w-full place-items-start justify-center">
                <div className="bg-white p-6 border rounded-lg shadow-md w-full gap-10">
                  <div className="grid grid-cols-2 gap-12 items-center">
                    {/* Input Field */}
                    <div className="space-y-3">
                      <h2 className="text-lg font-semibold">E-sign</h2>
                      <input
                        type="text"
                        placeholder="Enter Registration no."
                        className="border border-gray-300 rounded-md p-2 mb-6 col-span-2 w-full"
                        value={InputRegno}
                        onChange={(e) => {
                          const value = e.target.value;
                          setInputRegno(value);
                        }}
                      />
                      {/* Search button */}
                      <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        onClick={() => setOpenFirst(true)}
                      >
                        SEARCH
                      </button>

                      <ViewDocPopup
                        isOpen={openFirst}
                        onClose={() => setOpenFirst(false)}
                        onView={pdfUrl}
                        onNext={() => {
                          setOpenFirst(false); // Close First Modal
                          setOpenSecond(true); // Open Second Modal
                        }}
                      />
                      <PDFmodal
                        isOpen={openSecond}
                        onClose={() => setOpenSecond(false)}
                        pdfUrl={pdfUrl}
                        emailsendpdf={setEmailSent} // Pass setState function
                      ></PDFmodal>
                    </div>

                    <div className="place-items-center">
                      <img
                        src={logincrsimg} // Replace with actual image path
                        alt="E-sign illustration"
                        className="h-24"
                      />
                    </div>
                  </div>

                  {/* Image Section */}
                </div>
              </div>
              <div className="flex flex-col w-full  mt-2">
                <div className="bg-white p-2 border rounded-lg shadow-lg w-full overflow-y-auto">
                  <div className="flex justify-between mt-5">
                    <p className="text-md font-medium mb-3">
                      Registry Document :
                      {/* <button
                        onClick={(e) => {
                          // generatePdf(e);
                          window.open(
                            `$https://vreports.eregistrationukgov.in/Report/Pde_summary.aspx?PDE_ID=${pde}`,
                            "_blank"
                          );
                        }}
                        className="ms-3 px-6 py-2 bg-blue-500 text-white rounded-full text-sm"
                      >
                        View Pdf
                      </button> */}
                      <button
                        onClick={(e) => {
                          e.preventDefault(); // Prevent default behavior
                          window.open(
                            `https://vreports.eregistrationukgov.in/Report/Pde_summary.aspx?PDE_ID=${pde}`,
                            "_blank"
                          );
                        }}
                        className="ms-3 px-6 py-2 bg-blue-500 text-white rounded-full text-sm"
                      >
                        View Pdf
                      </button>
                    </p>
                    <div className="align-middle">
                      <button
                        className="ms-3 px-6 py-2 bg-blue-500 text-white rounded-full text-sm"
                        onClick={callapi}
                      >
                        Refresh
                      </button>
                    </div>
                  </div>

                  <hr></hr>

                  {/* <div className="mt-6">
                    <p className="text-md font-bold">First Party</p>
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      {partyDetailsData?.firstparty?.map((item, index) => (
                        <div
                          key={index}
                          className={`relative border-4  shadow-inner border-primary-900 flex items-start p-2 mb-2 rounded `}
                        >
                          <span
                            className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                              item.status === "Pending"
                                ? "bg-warning-500"
                                : item.status === "Signed"
                                ? "bg-success-500"
                                : item.status === "Declined"
                                ? "bg-danger-600"
                                : ""
                            }`}
                          >
                            {item.status}
                          </span>
                          <p className="text-sm font-bold">{item.sNo}.</p>
                          <img
                            className="w-32 h-32 object-cover ms-2 mr-6"
                            src={logincrsimg}
                            alt="Profile"
                          />

                          <div className="mr-10 text-sm">
                            <p className="text-gray-600">
                              <b>Name : </b>
                              {item.nameEng}
                            </p>
                            <p className="text-gray-600">
                              <b>Address : </b>
                              {item.address}
                            </p>
                            <p className="text-gray-600">
                              <b>D.O.B :</b> {item.dob}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div> */}
                  <div className="mt-6">
                    <p className="text-md font-bold">First Party</p>
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      {partyDetailsData?.firstparty?.map((item, index) => (
                        <div
                          key={index}
                          className={`relative border-4 shadow-inner flex items-start p-2 mb-2 rounded ${
                            item.status === "Pending"
                              ? "border-warning-500"
                              : item.status === "Signed"
                              ? "border-success-500"
                              : item.status === "Declined"
                              ? "border-danger-600"
                              : "border-primary-900"
                          }`}
                        >
                          <span
                            className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                              item.status === "Pending"
                                ? "bg-warning-500"
                                : item.status === "Signed"
                                ? "bg-success-500"
                                : item.status === "Declined"
                                ? "bg-danger-600"
                                : ""
                            }`}
                          >
                            {item.status}
                          </span>
                          <p className="text-sm font-bold">{item.sNo}.</p>
                          <img
                            className="w-32 h-32 object-cover ms-2 mr-6"
                            src={logincrsimg}
                            alt="Profile"
                          />
                          <div className="mr-10 text-sm">
                            <p className="text-gray-600">
                              <b>Name : </b>
                              {item.nameEng}
                            </p>
                            <p className="text-gray-600">
                              <b>Address : </b>
                              {item.address}
                            </p>
                            <p className="text-gray-600">
                              <b>D.O.B :</b> {item.dob}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="space-y-4">
                    <p className="text-md font-bold">Second Party</p>
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      {partyDetailsData?.secondparty?.map((item, index) => (
                        <div
                          key={index}
                          className={`relative border-4 shadow-inner flex items-start p-2 mb-2 rounded ${
                            item.status === "Pending"
                              ? "border-warning-500"
                              : item.status === "Signed"
                              ? "border-success-500"
                              : item.status === "Declined"
                              ? "border-danger-600"
                              : "border-primary-900"
                          }`}
                        >
                          <span
                            className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                              item.status === "Pending"
                                ? "bg-warning-500"
                                : item.status === "Signed"
                                ? "bg-success-500"
                                : item.status === "Declined"
                                ? "bg-danger-600"
                                : ""
                            }`}
                          >
                            {item.status}
                          </span>
                          <p className="text-sm font-bold">{item.sNo}.</p>
                          <img
                            className="w-32 h-32 object-cover ms-2 mr-6"
                            src={logincrsimg}
                            alt="Profile"
                          />
                          <div className="text-sm mr-10">
                            <p className="text-gray-600 ">
                              <b>Name : </b>
                              {item.nameEng}
                            </p>
                            <p className="text-gray-600">
                              <b>Address : </b>
                              {item.address}
                            </p>
                            <p className="text-gray-600">
                              <b>D.O.B :</b> {item.dob}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="space-y-4">
                    <p className="text-md font-bold">Witness</p>
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      {partyDetailsData?.witness?.map((item, index) => (
                        <div
                          key={index}
                          className={`relative border-4 shadow-inner flex items-start p-2 mb-2 rounded ${
                            item.status === "Pending"
                              ? "border-warning-500"
                              : item.status === "Signed"
                              ? "border-success-500"
                              : item.status === "Declined"
                              ? "border-danger-600"
                              : "border-primary-900"
                          }`}
                        >
                          <span
                            className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                              item.status === "Pending"
                                ? "bg-warning-500"
                                : item.status === "Signed"
                                ? "bg-success-500"
                                : item.status === "Declined"
                                ? "bg-danger-600"
                                : ""
                            }`}
                          >
                            {item.status}
                          </span>
                          <p className="text-sm font-bold">{item.sNo}.</p>
                          <img
                            className="w-32 h-32 object-cover ms-2 mr-6"
                            src={logincrsimg}
                            alt="Profile"
                          />
                          <div className="text-sm mr-10">
                            <p className="text-gray-600">
                              <b>Name : </b>
                              {item.nameEng}
                            </p>
                            <p className="text-gray-600">
                              <b>Address : </b>
                              {item.address}
                            </p>
                            <p className="text-gray-600">
                              <b>D.O.B :</b> {item.dob}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-64 h-full">
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Esign;
